import {ISimplePresentation, ISimplePresentationRunnerController} from "../SimplePresentationRunner";
import {Game} from "../Game";
import {IMonster, IMonsterWalk, IPosition} from "../server/IData";
import {gsap} from "gsap";
import {MonsterSymbol} from "../reels/MonsterSymbol";
import {Sound} from "../sound/Sound";
import { APISetting } from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";

export class BulldozerDriveRunner implements ISimplePresentation {

    public shouldRun(): boolean {
        return Game.model.canBulldozerDrive && !Game.model.gameData.suspendedAction;
    }

    public start(controller: ISimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = gsap.timeline({
                onComplete: () => {
                    controller.finish();
                }
            }),
            bzPath: IMonsterWalk[] = Game.model.gameData.bulldozerPath,
            carriedSymbolUserNode: IPosition = Game.model.gameData.carriedSymbolUserNode,
            monsters: IMonster[] = Game.model.gameData.monsters,
            monster: IMonster = monsters[Game.model.monsterIdxWithBZ],
            turnDuration: number = Game.apiPlugin.settings.get(APISetting.FAST_SPIN) ? 0.2/2: 0.2;

        tl.add(() => {
            controller.setSkipCallback(() => {
                this.onSkip(tl);
            });
        });

        if (monster) {
            const monsterSymbol: MonsterSymbol = Game.reelsView.reelModels[carriedSymbolUserNode.x].getMonsterSymbolAt(monster.symbol);

            tl.add(monsterSymbol.turnMonsterTowardsTarget(bzPath[0].x, bzPath[1].x, turnDuration));
            tl.add(monsterSymbol.driveBulldozer(bzPath, monster.path));
        }
    }

    private onSkip(tl: gsap.core.Timeline): void {
        tl.totalProgress(1);
        Game.soundPlayer.stopSound(Sound.BU_ACTIVATE);
        Game.soundPlayer.stopSound(Sound.BU_DRILL_LOOP);
        Game.soundPlayer.stopSound(Sound.BU_DRILL_LOOP_STOP);
        Game.soundPlayer.stopSound(Sound.TANK_START);
    }
}